import React from "react";

import { Box, Stack, Typography } from "@mui/material";
import { DashboardNewsIcon } from "assets/material-custom-icons";
import { ArticleRow } from "store/types";
import { formatNewsDate } from "utils/format-news-date";

interface InvestmentsNewsProps {
  data: ArticleRow;
}

export const InvestmentsNews: React.FC<InvestmentsNewsProps> = ({ data }) => (
  <Stack
    component="a"
    href={data.url || undefined}
    target="_blank"
    rel="noopener noreferrer"
    direction="row"
    alignItems="flex-start"
    gap="12px"
    sx={{
      py: "10px",
      borderBottom: "1px solid #DBE8F5",
      textDecoration: "none",
      color: "inherit",
      "&:last-child": { borderBottom: "none" },
      "&:hover .article-title": { color: "#26a6ae" }
    }}
  >
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        py: "2px",
        flexShrink: 0
      }}
    >
      <DashboardNewsIcon sx={{ fontSize: 20 }} />
    </Box>
    <Stack flex={1} minWidth={0} gap="4px">
      <Typography
        className="article-title"
        sx={{
          fontSize: "16px",
          fontWeight: 400,
          lineHeight: "24px",
          color: "#071F35",
          wordBreak: "break-word",
          transition: "color 0.12s"
        }}
      >
        {data.title}
      </Typography>
      {(data.source || data.category) && (
        <Typography sx={{ fontSize: "14px", lineHeight: "16px", color: "#496682" }}>
          {data.source && (
            <Box component="span" sx={{ fontWeight: 500 }}>
              {data.source}
            </Box>
          )}
          {data.source && data.category && ", "}
          {data.category}
        </Typography>
      )}
    </Stack>
    <Typography
      sx={{
        fontSize: "14px",
        lineHeight: "16px",
        color: "#496682",
        whiteSpace: "nowrap",
        flexShrink: 0,
        py: "2px"
      }}
    >
      {formatNewsDate(data.published_at)}
    </Typography>
  </Stack>
);
